<template>
    <div id="config-view">
        <div class="config-menu">
            <div class="logo"><img src="@/assets/logo.png" /></div>
            <LoadingDots v-if="isLoading" />
            <div class="config" v-if="!isLoading">
                <ConfigLink icon="user" link="/config/users">Utilisateurs</ConfigLink>
                <ConfigLink icon="street-view" link="/config/business">Groupes métier</ConfigLink>
                <ConfigLink icon="list-ul" link="/config/themes">Thèmes</ConfigLink>
                <ConfigLink icon="building" link="/config/objects">Groupes d'objets</ConfigLink>
                <ConfigLink link="/config/rights" v-if="settings.mod_validation_enable === '1'">
                    <font-awesome-layers slot="icon" class="fa-fw config-icon">
                        <font-awesome-icon icon="male" transform="grow-4 left-12" />
                        <font-awesome-icon icon="key" transform="shrink-6 rotate-315 left-2" />
                    </font-awesome-layers>
                    Droits de validation
                </ConfigLink>
                <ConfigLink icon="map" link="/config/footprints">Emprises</ConfigLink>
                <ConfigLink icon="tags" link="/config/tags">Attributs (tags)</ConfigLink>
                <ConfigLink icon="users" link="/config/contributors">Contributeurs OSM</ConfigLink>
                <ConfigLink icon="layer-group" link="/config/tiles">Serveurs de tuiles</ConfigLink>
                <ConfigLink icon="layer-group" link="/config/wms">Flux WMS</ConfigLink>
                <ConfigLink icon="layer-group" link="/config/wmts">Flux WMTS</ConfigLink>
                <ConfigLink
                    icon="arrows-alt-h"
                    link="/config/rattachment"
                    v-if="settings.mod_rattachment_enable === '1'"
                    >Sessions de rattachement</ConfigLink
                >
                <ConfigLink icon="cogs" link="/config/settings">Réglages</ConfigLink>
            </div>
            <MenuLink></MenuLink>
        </div>
        <div class="config-content"><slot></slot></div>
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
import ConfigLink from '@/components/ConfigLink';
import { authenticationService } from '@/services';
import MenuLink from '@/layouts/Menu.vue';

export default {
    data() {
        return {
            isLoading: true,
            settings: {
                mod_validation_enable: null,
                mod_export_enable: null,
                mod_rattachment_enable: null,
            },
            loaded_settings: [],
            user: authenticationService.currentUserValue,
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$http
                .get('/api/setting/')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
    },
    components: {
        ConfigLink,
        MenuLink,
        LoadingDots,
    },
};
</script>

<style lang="scss">
$menu-width: 240px;

#config-view {
    display: flex;
    flex-direction: row;

    .config-content {
        width: calc(100vw - #{$menu-width});
        height: 100vh;
        background-color: #f8f8f8;
    }

    .config-menu {
        width: $menu-width;
        background-color: #ffffff;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;

        .logo {
            width: $menu-width;
            height: 50px;
            background-color: #6c3e91;
            flex-shrink: 0;
            flex-grow: 0;
            flex-basis: 50px;

            display: flex;
            flex-direction: column;
            justify-content: center;

            > img {
                margin-left: 20px;
                display: block;
                max-width: 115px;
                height: auto;
            }
        }

        .config {
            flex-shrink: 0;
            flex-grow: 0;
            display: flex;
            flex-direction: column;
        }
    }
}

.title {
    color: #151b25;
    margin: 20px 30px;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
}
</style>
